import React, { useState, useEffect } from 'react'
import { bool, func } from 'prop-types'
import styled from 'styled-components'

import { H4 } from 'styles/typography'
import Modal, { ModalSection } from 'components/Modal'
import Button from 'components/button/Button'
import useDigitalData from 'hooks/useDigitalData'

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const VerifyEmailModal = ({ visible, sendVypeVerificationEmail, close }) => {
  const [sent, setSent] = useState(false)

  const { digitalData } = useDigitalData()

  useEffect(() => {
    digitalData.push({
      page: {
        virtualUrl: location.pathname + '/verify-email-modal',
        timestamp: new Date().getTime()
      }
    })
  }, [])

  return (
    <Modal
      visible={visible}
      close={() => {
        close()
        setTimeout(() => {
          setSent(false)
        }, 500)
      }}
    >
      <ModalSection>
        <Inner>
          <H4>Email verification</H4>
          <p>To be able to complete your order, we need to verify your email address. </p>
          {!sent ? (
            <Button
              theme="secondary"
              type="button"
              onClick={() => {
                sendVypeVerificationEmail()
                setSent(true)
              }}
            >
              Send verification email
            </Button>
          ) : (
            <span>We've sent you a verification email.</span>
          )}
        </Inner>
      </ModalSection>
    </Modal>
  )
}

VerifyEmailModal.propTypes = {
  visible: bool.isRequired,
  sendVypeVerificationEmail: func.isRequired,
  close: func.isRequired
}

export default VerifyEmailModal
